/** 貸出モーダルの前回入力（用務・用務先・経路）。日付は毎回今日にする。 */

const STORAGE_KEY = 'tpp.borrowDraft.v1';

export type TppBorrowDraft = {
  purpose: string;
  place: string;
  route: string;
};

export function loadTppBorrowDraft(): TppBorrowDraft | null {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as Partial<TppBorrowDraft>;
    const purpose = typeof parsed.purpose === 'string' ? parsed.purpose.trim() : '';
    const place = typeof parsed.place === 'string' ? parsed.place.trim() : '';
    const route = typeof parsed.route === 'string' ? parsed.route.trim() : '';
    if (!purpose && !place && !route) return null;
    return { purpose, place, route };
  } catch {
    return null;
  }
}

export function saveTppBorrowDraft(draft: TppBorrowDraft): void {
  try {
    localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({
        purpose: draft.purpose.trim(),
        place: draft.place.trim(),
        route: draft.route.trim(),
      })
    );
  } catch {
    // private mode 等
  }
}

export function clearTppBorrowDraft(): void {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    // private mode 等
  }
}
